import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchCustomerOrders as fetchOrder } from "services/orders.service";
import { Order } from "types/Order";

// Define the types for your initial state
interface customerOrdersContainerState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  collection: Order[];
}

const initialState: customerOrdersContainerState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  collection: [],
};

const customerOrdersContainerSlice = createSlice({
  name: "customer-orders",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(
      state: customerOrdersContainerState,
      action: PayloadAction<boolean>
    ) {
      state.isLoading = action.payload;
    },
    setError(
      state: customerOrdersContainerState,
      action: PayloadAction<{ error: string }>
    ) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state: customerOrdersContainerState, action: PayloadAction<any>) {
      state.collection = action.payload;
      state.isLoading = false;
    },
  },
});

const { actions, reducer } = customerOrdersContainerSlice;

export const { setDestroy, setLoading, setError, setData } = actions;
export default reducer;

export const fetchCustomerOrdersList =
  (companyId: string, customerId: string) => async (dispatch: any) => {
    dispatch(setLoading(true));
    try {
      const data = await fetchOrder({ customerId, companyId });
      dispatch(setData(data));
    } catch (e) {
      const error = "not_fetch";
      dispatch(setError({ error }));
    } finally {
      dispatch(setLoading(false));
    }
  };
